
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 2h9a2 2 0 012 2v1a1 1 0 01-2 0V4H6v16h9v-1a1 1 0 012 0v1a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2z","fill":"#5D6779"}}),_c('path',{attrs:{"d":"M16.795 16.295c.39.39 1.02.39 1.41 0l3.588-3.588a1 1 0 000-1.414l-3.588-3.588a1 1 0 00-1.411 1.411L18.67 11H10a1 1 0 000 2h8.67l-1.876 1.884a.999.999 0 00.001 1.411z","fill":"#5D6779"}})])
          )
        }
      }
    